import React from 'react'
import PropTypes from 'prop-types'
import SvgIcon from 'Components/SvgIcon'
import {
  _BinIconContainer,
  _TitleWithDeleteFlex,
  _Name,
} from './styles'

const TitleWithDelete = ({ title, deleteAlert }) => (
  <_TitleWithDeleteFlex justify={'between'} align={'center'}>
    <_Name>{title}</_Name>
    <_BinIconContainer
      aria-label="Delete your alerts"
      data-test-id="alertCardDelete"
      onClick={() => { deleteAlert(null) }}
    >
      <SvgIcon
        label={'Garbage bin'}
        name={'#icon-garbage-bin'}
        width={16}
        height={16}
      />
    </_BinIconContainer>
  </_TitleWithDeleteFlex>
)

TitleWithDelete.propTypes = {
  title: PropTypes.string,
  deleteAlert: PropTypes.func,
}

export default TitleWithDelete
